<template>
  <div class="profile-dropdown">
    <button
      class="dropdown-toggle text-start text-black-emphasis d-flex align-items-center p-0 position-relative bg-transparent border-0 transition lh-1"
      type="button"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      <div class="avatar-initials">{{ iniciales }}</div>
      <span class="md-none">
        <span class="d-block fw-bold text-title">{{ nombreUsuario }}</span>
        <span class="text-paragraph fs-14">{{ rolUsuario }}</span>
      </span>
    </button>
    <div class="dropdown-menu top-1 shadow-none border-0">
      <ul class="list-style">
        <li class="fs-14 d-block transition">
          <router-link to="/my-profile" class="d-block">Mi Perfil</router-link>
        </li>
        <li class="fs-14 d-block transition">
          <a href="javascript:void(0)" class="d-block text-danger" @click="cerrarSesion">
            Cerrar Sesión
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { logout, getUser } from '../../../services/authService';

export default {
  name: 'ProfileDropdown',
  computed: {
    user() { return getUser(); },
    nombreUsuario() {
      const u = this.user;
      if (!u) return 'Usuario';
      return u.nombre || u.usuario || 'Usuario';
    },
    rolUsuario() {
      const u = this.user;
      if (!u) return '';
      if (String(u.usuario || '').trim().toUpperCase() === 'ECAMPOSG') return 'Usuario de logística';
      const nivel = Number(u.nivelacceso || 0);
      if (nivel >= 3) return 'Administrador';
      if (nivel === 2) return 'Supervisor';
      return 'Usuario básico';
    },
    iniciales() {
      const nombre = this.nombreUsuario;
      const partes = nombre.trim().split(' ').filter(Boolean);
      if (partes.length >= 2) return (partes[0][0] + partes[1][0]).toUpperCase();
      return nombre.slice(0, 2).toUpperCase();
    },
  },
  methods: {
    cerrarSesion() {
      logout();
      this.$router.push('/login');
    },
  },
};
</script>

<style lang="scss" scoped>
.avatar-initials {
  width: 38px;
  height: 38px;
  border-radius: 8px;
  background: linear-gradient(135deg, #7c3aed, #a855f7);
  color: white;
  font-weight: 800;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  flex-shrink: 0;
  letter-spacing: 0.5px;
}
.profile-dropdown {
  .dropdown-toggle {
    &:after { display: none; }
  }
  span:nth-child(1) { margin-bottom: 5px; }
  span:nth-child(2) { color: #8a939b; }
  .dropdown-menu {
    box-shadow: 0 0 15px rgba(0,0,0,0.15) !important;
    padding: 14px 20px;
    top: 20px !important;
    ul li {
      margin-bottom: 7px;
      padding-bottom: 7px;
      border-bottom: 1px solid rgba(0,0,0,0.03);
      &:last-child { margin-bottom: 0; padding-bottom: 0; border-bottom: none; }
      a:hover { color: var(--secondaryColor); padding-left: 5px; }
    }
  }
}
</style>
